import Axios from "../util/axiosInstance";

export const getAllProjects = (params) => {
    return Axios.get("/api/Messages/GetAllChatProjects", { params });
}

export const getAllChatGroups = (params) => {
    return Axios.get("/api/Messages/GetAllChatGroups", { params });
}

export const getRepProjects = (params) => {
    return Axios.get("/api/Messages/GetAllRepProjects", { params });
};

export const getRepProjectDetails = (params) => {
    return Axios.get("/api/Messages/GetRepProjectDetails", { params })
}

export const getTwilioChatToken = (params) => {
    return Axios.get("/api/Messages/GetAccessToken", { params })
}

export const getProjectChats = (projectId, email) => {
    return Axios.get(`/api/Messages/GetProjectChatIds?projectId=${projectId}&User1Email=${email}`)
}

export const postNewProjectChat = (payload) => {
    return Axios.post("/api/Messages/Post", payload)
}

export const getUserGroupChat = (params) => {
    return Axios.get("api/Messages/GetGroupChat", { params })
}

export const addUserGroupChat = (payload) => {
    return Axios.post("/api/Messages/AddGroupChat", payload)
}

export const addUserToGroupChat = (payload) => {
    return Axios.post("/api/Messages/AddGroupMember", payload)
}

export const removeFromGroup = (params) => {
    return Axios.delete(`/api/Messages/LeaveGroupChat`, { params })
}

export const renameGroupName = (payload) => {
    return Axios.put("/api/Messages/RenameGroup", payload)
}

export const sendMentionEmail = (payload) => {
    return Axios.post("/api/Messages/SendEmailToMentioned", payload)
}

export const updateChatWelcomeModal = () => {
    return Axios.put("/api/Messages/UpdateMsgWelcomeModal", {})
}

export const getChatWelcomeModal = () => {
    return Axios.get("/api/Messages/GetMsgWelcomeModal")
}

export const createGeneralGroup = (payload) => {
    return Axios.post("/api/Messages/GenerateGeneralGroup", payload)
}

export const DownloadBlobByEntity = (guid, entityType, entityId) => {
    return Axios.get(`/api/Blob/GetByEntity?blobNameGUID=${guid}&entityName=${entityType}&entityId=${entityId}`, { responseType: "arraybuffer" })
}

export const ChatFileUpload = (projectId, entityType,payload, progressConfig) => {
    let url = `/api/Blob/UploadDocument?entityType=${entityType}&entityId=${projectId}`
  
    return Axios.put(
      url,
      payload,
      progressConfig
    );
  };
  
export const DownloadChatDocument = (guid, entityType, entityId, onProgress, TTARep=false) => {
    return Axios.get(`/api/Blob/GetByEntity?blobNameGUID=${guid}&entityName=${entityType}&entityId=${entityId}`, {
      responseType: "blob",
      onDownloadProgress: (progressEvent) => {
        const progress = Math.round(
          (progressEvent.loaded / progressEvent.total) * 100
        );
        onProgress(progress);
      },
    });
  };